import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FormRegistrarEmpresaScheme } from "../../../Models/Schemas/register-empresa-schema";
import { FORM_REGISTRAR_EMPRESA } from "../../../Constants/registrarEmpresa";
import Button from "../../Elements/Button/Button";
import { setErrorFormSimpleUtil } from "../../../Utilities/Forms/errors";
import useForm from "../../../Hooks/useForm";
import Input from "../../Elements/Input/Input";
import Loader from "../../Elements/Loader/Loader";
import useStore from "../../../useStore";
import { useToast } from "../../../Contexts/Toast/toast.provider";

const RegistrarEmpresa = () => {
  const navigate = useNavigate();
  const showToast = useToast();
  const {
    fetchRegistrarEmpresa,
    loading,
    error,
  } = useStore();

  const { values, errors, touched, handleBlur, handleChange, isValid } =
    useForm(FORM_REGISTRAR_EMPRESA, FormRegistrarEmpresaScheme);

  useEffect(() => {
    handleResponse();
  }, [error]);

  useEffect(() => {
    const handleSuccess = () => {
      showToast("success", "Empresa registrada exitosamente");
      navigate("/empresa");
    };
    window.addEventListener("empresaRegistrada", handleSuccess);
    return () => window.removeEventListener("empresaRegistrada", handleSuccess);
  }, []);

  const handleResponse = () => {
    if (error) {
      const message =
        error instanceof Error
          ? error.message
          : error?.error || "Error desconocido";
      showToast("error", message);
    }
  };

  const submit = () => {
    if (values) fetchRegistrarEmpresa(values);
  };

  if (loading) return <Loader />;

  return (
    <div className="container mt-4">
      <div className="row justify-content-center">
        <div className="col-12 col-md-6">
          <h2 className="mb-4">Registrar empresa</h2>
          <form autoComplete="off">
            <div className="row g-3">
              <div className="col-12">
                <Input
                  value={values.nombre}
                  label="Nombre"
                  onChange={handleChange("nombre")}
                  onBlur={handleBlur("nombre")}
                  error={setErrorFormSimpleUtil(errors, touched, "nombre")}
                  success={!setErrorFormSimpleUtil(errors, touched, "nombre")}
                />
              </div>
              <div className="col-12">
                <Input
                  value={values.telefono}
                  label="Teléfono"
                  onChange={handleChange("telefono")}
                  onBlur={handleBlur("telefono")}
                  error={setErrorFormSimpleUtil(errors, touched, "telefono")}
                  success={!setErrorFormSimpleUtil(errors, touched, "telefono")}
                />
              </div>
              <div className="col-12">
                <Input
                  value={values.correo}
                  label="Correo"
                  onChange={handleChange("correo")}
                  onBlur={handleBlur("correo")}
                  error={setErrorFormSimpleUtil(errors, touched, "correo")}
                  success={!setErrorFormSimpleUtil(errors, touched, "correo")}
                />
              </div>
              <div className="col-12">
                <Input
                  value={values.empresa}
                  label="Empresa"
                  onChange={handleChange("empresa")}
                  onBlur={handleBlur("empresa")}
                  error={setErrorFormSimpleUtil(errors, touched, "empresa")}
                  success={!setErrorFormSimpleUtil(errors, touched, "empresa")}
                />
              </div>
              <div className="col-12 mt-2">
                <Button
                  text="Registrar"
                  color="green"
                  fill
                  action={submit}
                  disabled={!isValid}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegistrarEmpresa;